import { render, staticRenderFns } from "./selectShop.vue?vue&type=template&id=2459d7d6"
import script from "./selectShop.vue?vue&type=script&lang=js"
export * from "./selectShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports